// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"baf0974e","265":"a288b739","743":"36c35a85","926":"cedcb6b7"}[chunkId] + ".chunk.css";
};